import React, { useState, useEffect, useRef } from "react";
import Seo from "./Seo";
import imgpurchase from "../Assets/images/steptodown.com787175.jpg";
import imgslider3 from "../Assets/slider3.jpeg";
import imgslider1 from "../Assets/slider1.jpeg";
import imgslider2 from "../Assets/slider2.jpeg";
import imgrepair from "../Assets/images/advisory.jpg";
import imgcpv from "../Assets/images/verification.jpg";
import amcImage from "../Assets/images/excellence.jpg";
import kotakLogo from "../Assets/clients/Kotak Mahindra Bank logo.svg";
import rblLogo from "../Assets/clients/rbl-bank-ltd-vector-logo-2022.svg";
import idfcLogo from "../Assets/clients/idfc-first-bank-logo-brandlogos.net_b09qwqpa3.svg";
import sbiLogo from "../Assets/clients/SBI Card_id6ifacJEt_1.svg";
import tataLogo from "../Assets/clients/Tata Capital_idTUFO3iTV_1.svg";
import bajajLogo from "../Assets/clients/bajaj-finance-logo-4F25F51s0e_brandlogos.net.svg";
import iiflLogo from "../Assets/clients/IIFL Finance.svg";
import adityaBirlaLogo from "../Assets/clients/aditya-birla-group-seeklogo.svg";
import northernArcLogo from "../Assets/clients/logosC151575976566160png1.png";
import paytmLogo from "../Assets/clients/paytm-logo-brandlogos.net_vyqvr1ph2.svg";
import { useNavigate } from "react-router-dom";

const images = [
  {
    src: imgslider1,
    link: "/products",
    text: "Buy Now",
    align: "bottom-10 left-1/2 transform -translate-x-1/2",
  },
  {
    src: imgslider2,
    link: "/services",
    text: "Upgrade For Better Experience",
    align: "top-20 left-3/4 transform -translate-x-1/2",
  },
  {
    src: imgslider3,
    link: "/rental",
    text: "Rent Your System",
    align: "bottom-72 left-3/4 transform -translate-x-1/2",
  }
];

// const StatItem = ({ target, label }) => {
//   const numberRef = useRef();

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             const element = entry.target;
//             const target = +element.getAttribute("data-target");
//             const duration = 2000; // Duration of animation in milliseconds
//             const start = 0;
//             const startTime = performance.now();

//             const updateCounter = (currentTime) => {
//               const elapsedTime = currentTime - startTime;
//               const progress = Math.min(elapsedTime / duration, 1);
//               const currentNumber = Math.floor(
//                 progress * (target - start) + start
//               );
//               element.textContent = currentNumber;

//               if (progress < 1) {
//                 requestAnimationFrame(updateCounter);
//               }
//             };

//             requestAnimationFrame(updateCounter);

//             observer.unobserve(element); // Stop observing the element once animation starts
//           }
//         });
//       },
//       {
//         threshold: 0.5, // Trigger animation when 50% of the element is visible
//       }
//     );

//     observer.observe(numberRef.current);
//   }, [target]);

//   return (
//     <div className="stat-item flex-col text-center p-4 cs-5 ">
//       <div
//         ref={numberRef}
//         data-target={target}
//         className="number text-4xl font-bold text-cs3 "
//       >
//         0
//       </div>
//       <p className="text-cs3 font-medium label mt-2">{label}</p>
//     </div>
//   );
// };

const Home = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
   const intervalRef = useRef(null);
  // const [intervalId, setIntervalId] = useState(null);
  // const [isManual, setIsManual] = useState(false);
  let touchStartX = 0;

   const handleNavItemClick = (path) => {
     navigate(`/${path}`);
     setIsOpen(false); // Close the navbar on item click for smaller screens
   };

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // Adjust the threshold as per your requirement
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

   const startInterval = () => {
     if (intervalRef.current) {
       clearInterval(intervalRef.current);
     }
     intervalRef.current = setInterval(() => {
       handleNext();
     }, 5000); // Change image every 3 seconds
   };

   useEffect(() => {
     startInterval();
     return () => clearInterval(intervalRef.current);
     // eslint-disable-next-line
   }, []);

   useEffect(() => {
     startInterval();
     // eslint-disable-next-line
   }, [currentIndex]);

   const handlePrevious = () => {
     setCurrentIndex((prevIndex) =>
       prevIndex === 0 ? images.length - 1 : prevIndex - 1
     );
   };

   const handleNext = () => {
     setCurrentIndex((prevIndex) =>
       prevIndex === images.length - 1 ? 0 : prevIndex + 1
     );
   };

   const handleTouchStart = (e) => {
     touchStartX = e.touches[0].clientX;
   };

   const handleTouchMove = (e) => {
     if (touchStartX - e.touches[0].clientX > 50) {
       handleNext(); // Swipe left
     } else if (touchStartX - e.touches[0].clientX < -50) {
       handlePrevious(); // Swipe right
     }
   };

  return (
    <div className="min-h-screen flex-col justify-center items-center cs-5">
      {/* <div>home</div> */}
      <Seo
          title="Randeva Advisory Services Pvt Ltd"
          description="Randeva Advisory Services Pvt Ltd is a Private Limited establishment with over 15 years of experience in the recovery and collection sector."
          keywords="Randeva Advisory Services, Dues Collection & Recovery, Contact Point Verification, Strategic Advisory, Turnover Excellence"
        />
      {/* image carousel */}
      <div className="relative w-full mx-auto mt-0" style={{ height: "69vh" }}>
        <div className="overflow-hidden relative h-full">
          <div
            className="relative h-full w-full"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
          >
            {images.map((image, index) => (
              <div
                key={index}
                className={`absolute top-0 left-0 w-full h-full ${
                  index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
                }`}
                style={{ transitionDuration: "2s" }}
              >
                <img
                  src={image.src}
                  alt={`Slide ${index + 1}`}
                  className="w-full h-full object-cover object-center rounded-3xl"
                />{/*
                <button
                  className={`absolute ${image.align} bg-cs2 text-white hover:bg-cs4 hover:text-cs2 font-bold cursor-pointer px-8 py-4 text-3xl rounded-md`}
                  onClick={() => navigate(image.link)}
                >
                  {image.text}
                </button>*/}
              </div>
            ))}
          </div>
        </div>
        {/* <div className="md:h-10 bg-white"> &nbsp;</div> */}
        <button
          className={
            isSmallScreen
              ? "absolute left-0 bottom-1/2 transform translate-y-full bg-cs4 group text-white p-3 rounded-full z-10"
              : "absolute -left-5 bottom-1/2 transform translate-y-full bg-cs1 group text-white px-3 p-4 w-14 hover:bg-cs4 rounded-full transition duration-300 hover:scale-105 ease-in-out hover:text-white z-10 "
          }
          id="arrow"
          onClick={handlePrevious}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="40"
            viewBox="0 0 11 20"
            className="md:w-6 w-4 fill-current transition duration-300 group-hover:scale-75 ease-in-out mx-auto" // Added fill-current here
          >
            <path
              fillRule="evenodd"
              d="M10.634.292a1.063 1.063 0 0 0-1.464 0L.607 8.556a1.95 1.95 0 0 0 0 2.827l8.625 8.325c.4.385 1.048.39 1.454.01a.975.975 0 0 0 .01-1.425l-7.893-7.617a.975.975 0 0 1 0-1.414l7.83-7.557a.974.974 0 0 0 0-1.413"
            ></path>
          </svg>
        </button>
        <button
          style={{ transform: "rotate(180deg)" }}
          className={
            isSmallScreen
              ? "absolute right-0 top-1/2 transform translate-y-full bg-cs4 group text-white p-3 rounded-full z-10"
              : "absolute -right-5 top-1/2 transform translate-y-full bg-cs1 text-white group px-3 p-4 w-14 hover:bg-cs4 rounded-full transition duration-300 hover:scale-105 ease-in-out hover:text-white z-10"
          }
          id="arrowrev"
          onClick={handleNext}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="40"
            viewBox="0 0 11 20"
            // transform="rotate(180, 1.5, 0)"
            className="md:w-6 w-4 fill-current transition duration-300 group-hover:scale-75 ease-in-out mx-auto" // Added fill-current here
          >
            <path
              fillRule="evenodd"
              d="M10.634.292a1.063 1.063 0 0 0-1.464 0L.607 8.556a1.95 1.95 0 0 0 0 2.827l8.625 8.325c.4.385 1.048.39 1.454.01a.975.975 0 0 0 .01-1.425l-7.893-7.617a.975.975 0 0 1 0-1.414l7.83-7.557a.974.974 0 0 0 0-1.413"
            ></path>
          </svg>
        </button>
      </div>

<div className={
        isSmallScreen ? "mt-20" : "mt-52"
      }>

</div>
      <h1 className="text-4xl font-bold text-center text-cs8 mt-8 mb-4">
        Strategic Debt Recovery & Advisory Services
      </h1>
      <h3 className="text-xl font-bold text-center text-cs4 mt-8 mb-4">
        A proven, fifteen-year-old establishment committed to clean, reliable, and effective dues collections for India’s leading MNC banks and NBFCs.
      </h3>
      <div className={
        isSmallScreen ? "mt-20" : "mt-52"
      }>

</div>

      {/* Services  */}
      <div className="bg-cs2 rounded-xl pl-4 pr-4 pb-4">
        <h1 className="text-2xl font-bold text-center text-cs7 mt-20 pt-6 mb-4">
          Core Expertise
        </h1>
        <div className="flex items-center justify-center">
          <hr className="h-2 w-2/4 border-cs7 pb-4" />
        </div>

        {/* Services list */}
        <div className="flex flex-col sm:flex-row space-y-5 sm:space-y-0 sm:space-x-4 p-4 items-center justify-center">
          <button
            className="flex-grow"
          >
            <div className="max-w-full sm:max-w-sm rounded-xl overflow-hidden shadow-lg bg-cs5 service transition duration-300 ease-in-out md:contrast-75 hover:contrast-100">
              <img
                className="w-full h-48 object-cover"
                src={imgpurchase}
                alt="Dues Collection & Recovery"
              />
              <div className="px-6 py-4">
                <div className="font-bold text-xl text-cs3 mb-2">
                  Dues Collection & Recovery
                </div>
                <p className="text-cs1 text-base">
                  Specialized management of high-volume debt portfolios for MNC Banks and NBFCs with a focus on sustainable results.
                </p>
              </div>
              <div className="px-6 pt-1 pb-2">
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag1
                </span>
                <span className="inline-block  bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag2
                </span>
                {/* <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                #tag3
              </span> */}
              </div>
            </div>
          </button>

          <button
            className="flex-grow"
          >
            <div className="max-w-full sm:max-w-sm rounded-xl overflow-hidden shadow-lg bg-cs5 service transition duration-300 ease-in-out md:contrast-75 hover:contrast-100">
              <img
                className="w-full h-48 object-cover"
                src={imgcpv}
                alt="Contact Point Verification"
              />
              <div className="px-6 py-4">
                <div className="font-bold text-cs3 text-xl mb-2">
                  Contact Point Verification
                </div>
                <p className="text-cs1 text-base">
                  Deep-rooted field experience in verifying customer credentials to ensure data integrity for banking partners.
                </p>
              </div>
              <div className="px-6 pt-1 pb-2">
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag1
                </span>
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag2
                </span>
                {/* <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                #tag3
              </span> */}
              </div>
            </div>
          </button>

          <button
            className="flex-grow"
          >
            <div className="max-w-full sm:max-w-sm rounded-xl overflow-hidden shadow-lg bg-cs5 service transition duration-300 ease-in-out md:contrast-75 hover:contrast-100">
              <img
                className="w-full h-48 object-cover"
                src={imgrepair}
                alt="Strategic Advisory"
              />
              <div className="px-6 py-4">
                <div className="font-bold text-cs3 text-xl mb-2">
                  {" "}
                  Strategic Advisory
                </div>
                <p className="text-cs1 text-base">
                  Leveraging 15 years of industry maturity to offer judicious and prompt handling of complex contractual assignments.
                </p>
              </div>
              <div className="px-6 pt-1 pb-2">
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag1
                </span>
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag2
                </span>
                {/* <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                #tag3
              </span> */}
              </div>
            </div>
          </button>

          <button
            className="flex-grow"
          >
            <div className="max-w-full sm:max-w-sm rounded-xl overflow-hidden shadow-lg bg-cs5 service transition duration-300 ease-in-out md:contrast-75 hover:contrast-100">
              <img
                className="w-full h-48 object-cover"
                src={amcImage}
                alt="Turnover Excellence"
              />
              <div className="px-6 py-4">
                <div className="font-bold text-cs3 text-xl mb-2">
                  Turnover Excellence
                </div>
                <p className="text-cs1 text-base">
                  Consistently exceeding targets with a monthly recovery proximity of 85% or above.
                </p>
              </div>
              <div className="px-6 pt-1 pb-2">
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag1
                </span>
                <span className="inline-block bg-cs1 rounded-full px-3 py-1 text-sm font-semibold text-cs5 mr-2 mb-2">
                  #tag2
                </span>
                {/* <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">
                #tag3
              </span> */}
              </div>
            </div>
          </button>
        </div>
      </div>

      {/* contact us card  */}

      <div className=" flex item-center justify-center md:pt-6 pt-16 md:mt-20 pb-4">
        <div className="animated-gradient w-5/6 md:rounded-full rounded-3xl flex-col item-center justify-center md:h-28 h-20">
          <div className="text-white  flex items-center justify-center pt-6 md:text-4xl text-base text-center">
            We Provide the Best Service in Industry
          </div>
          <div className="text-white flex items-center justify-center md:pt-5 h-18">
            <button
              className="md:w-48 pt-3 pb-3 bg-cs1 flex font-semibold items-center justify-between px-4 rounded-full allproduct hover:bg-cs4"
              onClick={() => handleNavItemClick("contact")}
            >
              <div className="flex items-center justify-between w-full">
                <div className="ml-2 flex-nowrap">Contact Us Today</div>
                <div className="">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    style={{ fill: "white" }}
                    viewBox="0 0 32 32"
                    id="arrow"
                  >
                    <path d="M4 15a1 1 0 0 0 1 1h19.586l-4.292 4.292a1 1 0 0 0 1.414 1.414l6-6a.99.99 0 0 0 .292-.702V15c0-.13-.026-.26-.078-.382a.99.99 0 0 0-.216-.324l-6-6a1 1 0 0 0-1.414 1.414L24.586 14H5a1 1 0 0 0-1 1z"></path>
                  </svg>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Authorized Seller of  */}
      <div className="mt-20 md:mt-28">
        <h1 className="text-2xl font-semibold text-center text-cs7  mb-4">
          Our Partners / Clients
        </h1>
        <div className="flex items-center justify-center">
          <hr className="h-2 w-2/4 border-cs7 " />
        </div>
        <div
          className={
            isSmallScreen
              ? "flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 p-4 items-center justify-center icon-grid"
              : "flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-14 p-4 items-center justify-center icon-grid3 pb-12"
          }
        >
          <div className="flex items-center justify-center">
            <img 
        src={kotakLogo} 
        alt="Logo" 
        style={{ width: '160px' }}
      />
</div>
          <div>
            <img 
        src={rblLogo} 
        alt="Logo" 
        style={{ width: '160px' }}
      />
</div>
          <div>
            <img 
        src={idfcLogo} 
        alt="Logo" 
        style={{ width: '160px' }}
      />
          </div>

          {/* here here */}
          <div>
            <img 
        src={sbiLogo} 
        alt="Logo" 
        style={{ width: '180px' }}
      />
          </div>
          <div>
            <img 
        src={tataLogo} 
        alt="Logo" 
        style={{ width: '240px' }}
        className={
        isSmallScreen ? "" : "-ml-8"
      }
      />
          </div>
          <div>
            <img 
        src={bajajLogo} 
        alt="Logo" 
        style={{ width: '160px' }}
        // className="-ml-6"
      />
          </div>

          <div>
            <img 
        src={iiflLogo} 
        alt="Logo" 
        style={{ width: '200px' }}
        className={
        isSmallScreen ? "" : "-ml-4"
      }
      />
          </div>
          <div>
            <img 
        src={adityaBirlaLogo} 
        alt="Logo" 
        style={{ width: '160px' }}
      />
          </div>

          <div>
            <img 
        src={northernArcLogo} 
        alt="Logo" 
        style={{ width: '160px' }}
      />
          </div>
          <div>
            <img 
        src={paytmLogo} 
        alt="Logo" 
        style={{ width: '160px' }}
      />
          </div>
        </div>
      </div>

      {/* <div className="mt-28 md:mt-2">
        <h1 className="text-2xl font-semibold text-center text-cs3 md:mt-3 mb-4">
          Our Clients
        </h1>
        <div className="flex items-center justify-center">
          <hr className="h-2 w-2/4 border-cs4 pb-4" />
        </div>
        <div className="stats-section grid grid-cols-1 sm:grid-cols-4 gap-6 p-8 cs-5">
          <StatItem target={25} label="ALLIANCES WITH BRANDS" />
          <StatItem target={400} label="PRODUCTS" />
          <StatItem target={180} label="CLIENTS" />
          <StatItem target={200} label="PROJECTS" />
        </div>
      </div> */}
    </div>
  );
};

export default Home;
